import { useCallback, useRef } from "react";

// https://www.ag-grid.com/react-data-grid/fine-tuning/
export function useDynamicCallback(callback) {
    const ref = useRef(null);
    ref.current = callback;
    return useCallback((...args) => ref.current.apply(null, args), []);
}
